import React from "react";
import { Button, Dropdown, Input, Menu, Tabs, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { BsSortUp } from "react-icons/bs";
import { FiFilter } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import BotsList from "./components/left/BotsList";

const ChatsList = () => {
  const { TabPane } = Tabs;
  const { t } = useTranslation();
  return (
    <>
      {/* Filter and Search Bar on the same line */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "50px",
          backgroundColor: "#fff",
        }}
      >
        <Input
          style={{ width: "100%", borderRadius: "0px" }}
          suffix={
            <>
              {/* Type Filters */}
              <Dropdown
                overlay={
                  <Menu
                  //   onClick={handleFilter}
                  //   selectedKeys={[filterValue]}
                  >
                    <Menu.Item key="All">
                      {t("chatMessages.chatList.all")}
                    </Menu.Item>
                    <Menu.Item key="open">
                      {t("chatMessages.chatList.open")}
                    </Menu.Item>
                    <Menu.Item key="inProgress">
                      {t("chatMessages.chatList.inProgress")}
                    </Menu.Item>
                    <Menu.Item key="closed">
                      {t("chatMessages.chatList.closed")}
                    </Menu.Item>
                    <Menu.Item key="pending">
                      {t("chatMessages.chatList.pending")}
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button
                  type="text"
                  icon={<FiFilter style={{ marginRight: "5px" }} />}
                  size="small"
                />
              </Dropdown>

              {/* Sorting Filters */}
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="1"
                      onClick={() => message.info("Coming soon")}
                    >
                      {t("chatMessages.chatList.newest")}
                    </Menu.Item>
                    <Menu.Item
                      key="2"
                      onClick={() => message.info("Coming soon")}
                    >
                      {t("chatMessages.chatList.oldest")}
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button type="text" icon={<BsSortUp />} size="small" />
              </Dropdown>
            </>
          }
          bordered={false}
          prefix={<SearchOutlined />}
          placeholder={t("chatMessages.chatList.searchPH")}
        />
      </div>

      {/* Tabs for Chats, Bots, and Agents */}
      <Tabs
        defaultActiveKey="bots"
        // activeKey={activeListTab}
        // onChange={handleChatsListTabChange}
        centered={true}
        style={{
          marginBottom: "5px",
        }}
      >
        {/* Bots */}
        <TabPane tab={t("chatMessages.chatList.chatbots")} key="bots">
          <BotsList
          // chatbotNames={chatbotNames}
          // selectedBotId={selectedBotId}
          // handleSelectChatbot={handleSelectChatbot}
          />
        </TabPane>
      </Tabs>
    </>
  );
};

export default ChatsList;
